<!--道路AI智能养护巡查系统-->
<template>
    <div class="system-container">
        <div class="section">
            <div class="section-content">
                <div class="title">平台概述</div>
                <p class="text">
                    道路AI智能巡检系统对巡检车进行轻量级改装后，通过车辆巡检，利用先进的AI视觉算法，检测路面病
                    害(横纵裂缝、龟裂、坑槽、抛洒物等)、交通安全设施损坏（交通标志牌、标线、护栏等）自动关联道
                    路病害的精确位置，通过视频联动进行确认。依靠路面病害识别算法，实时框选路面病害并进行参数的
                    自动计算和标注，从而实现检测结果“可视”，对于框选识别的病害实时并推送至AI巡检云平台进行查看、
                    统计分析、可视化展示，生成巡检报告和病害清单，支持无缝对接智慧公路养护综合管理平台，实现病害
                    快速采集-派发养护任务-养护施工-验收督查-计量支付全流程智能化、科学化、精细化管理。
                </p>
                <img class="image" src="@/assets/image/prescription/func_model1.png" alt/>
                <img class="mobile-image" src="@/assets/image/prescription/func_model1_small.png" alt/>
            </div>
        </div>
        <div class="section bg">
            <div class="section-content">
                <div class="title">系统介绍</div>
                <Carousel class="carousel" :images="imageList"/>
                <el-carousel class="mobile-carousel" height="200px" trigger="click" >
                    <el-carousel-item v-for="(item,index) in imageList" :key="index">
                        <img
                            :src="item"
                            style="width: 100%;height: 100%;
                            object-fit: scale-down"
                            alt
                        />
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="section mobile-detail">
            <div class="section-content">
                <div class="title">产品详情</div>
                <div class="panel">
                    <img class="img" src="@/assets/image/prescription/cpxq_logo.png" alt style=""/>
                    <ul class="list">
                        <li class="list-item" v-for="(item,index) in productList" :key="index">
                            <div class="label">{{ item.label }}</div>
                            <div class="info">{{ item.info }}</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="section" style="background-color: #EAF3FF;">
            <div class="section-content">
                <div class="title">产品特点</div>
                <div class="synopsis">
                    <img class="img" src="@/assets/image/prescription/cptd.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//components
import Carousel from "@/components/Carousel";

export default {
    components: {
        Carousel
    },
    name: "roadAIMaintain",
    data() {
        return {
            imageList: [
                require('@/assets/image/prescription/AI_sys_1.png'),
            ],
            productList: [
                {label: '产品构成', info: '硬件(边缘计算机+摄像头+定位模块)+AI巡检云平台+养护综合管理平台+APP。'},
                {label: '适配车辆', info: '适合轿车、SUV、皮卡等多种车型。'},
                {
                    label: '巡检功能',
                    info: '快速准确地检测出路面病害，输出病害详细信息，结合定位模块，可准确定位病害位置，辅助现场处置。'
                },
                {label: '应用场景', info: '支持高速公路、普通公路、市政道路、农村公路多个场景。'},
                {
                    label: '识别范围',
                    info: '路面病害(横纵裂缝、龟裂、坑槽、抛洒物等)、交通安全设施损坏（交通标志牌、标线、护栏等）。'
                },
            ]
        };
    },
    mounted() {
    },
    methods: {
        //切换图片
        toggleImage(type) {
            this.$refs.carousel[type]();
        }
    }
}
</script>


<style scoped lang="scss">
.system-container {
    height: 100%;
    width: 100%;

    .bg {
        background-image: url("~@/assets/image/prescription/xtjs_bg.png");
    }

    .section {
        height: 100%;
        width: 100%;

        .section-content {
            margin: 0 auto;
            width: 1200px;
            padding: 80px 0;

            .title {
                text-align: center;
                font-size: 36px;
            }

            .text {
                margin-top: 40px;
                text-indent: 2em;
                line-height: 32px;
                text-align: justify;
                font-size: 20px;
            }

            .image {
                margin-top: 60px;
                width: 100%;
            }

            .mobile-image {
                display: none;
            }
        }
    }

    .mobile-carousel {
        display: none;
    }

    .panel {
        margin-top: 80px;
        display: flex;
        align-items: center;

        .img {
            height: 336px;
            width: 336px;
        }

        .list {
            padding-left: 30px;

            .list-item {
                margin-bottom: 30px;

                .label {
                    font-size: 24px;
                    font-weight: bold;
                    color: #0079fe;

                    &::before {
                        content: "";
                        display: inline-block;
                        width: 14px;
                        height: 14px;
                        background-image: url("~@/assets/image/prescription/icon_34.png");
                        background-size: 100% 100%;
                        margin-right: 4px;
                        transform: translateY(-2px);
                    }
                }

                .info {
                    padding: 16px 0 0 16px;
                    font-size: 20px;
                    line-height: 30px;
                }
            }
        }
    }

    .synopsis {
        margin-top: 50px;
        text-align: center;

        .img {
            width: 1200px;
            height: 600px;
        }
    }
}

@import "./style.scss";
</style>
